import React from 'react';
import usePortal from 'react-useportal';
import { clsx } from '../utils/utils';
import ShareModal from './ShareModal';

import * as styles from './ShareModalOverlay.module.scss';

export interface ShareModalOverlayProps {
  shareUrl: string;
  className?: string;
  onClose: () => void;
}

const ShareModalOverlay = ({
  shareUrl,
  className,
  onClose,
}: ShareModalOverlayProps): React.ReactElement => {
  const { Portal } = usePortal();
  return (
    <Portal>
      <div className={clsx(styles.overlay, className)} onClick={onClose}>
        <div className={styles.shareModalContainer} onClick={e => e.stopPropagation()}>
          <ShareModal shareUrl={shareUrl} onCloseClick={onClose}></ShareModal>
        </div>
      </div>
    </Portal>
  );
};

export default ShareModalOverlay;
